export class Transaction {
  public id : string;
  public trx_id : string;
  public amount: string;
  public bank_checksum: string;
  public bank_end2end_id: string;
  public bank_id: string;
  public barcode: string;
  public barcode__icontains: string;
  public cart_id: string;
  public client_checksum: string;
  public client_reference: string;
  public pos_id: string;
  public status: string;
  public user_account_bic: string;
  public user_account_iban: string;
  public user_email: string;
  public user_first_name: string;
  public user_id: string;
  public user_last_name: string;
  public customer_reference : string;
  public customer : string
  public creation_date : string
  public client_id : string
}
